import { withKeys as _withKeys, mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26e1259f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value", "enterkeyhint"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drive_ui_wrapper = _resolveComponent("drive-ui-wrapper")!

  return (_openBlock(), _createBlock(_component_drive_ui_wrapper, {
    title: _ctx.title,
    hideBorder: _ctx.hideBorder,
    error: _ctx.error
  }, {
    default: _withCtx(() => [
      _createElementVNode("textarea", _mergeProps({
        class: "case-description",
        value: _ctx.modelValue,
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
        onKeypress: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"])),
        enterkeyhint: _ctx.enterkeyhint,
        ref: "input",
        id: "caseName"
      }, _ctx.$attrs, {
        class: {'bold': _ctx.bold}
      }), null, 16, _hoisted_1)
    ]),
    _: 1
  }, 8, ["title", "hideBorder", "error"]))
}